var map = {
	"./MastercardLogo.png": 3598,
	"./VISALogo.png": 3041,
	"./email/1-bullet@2x.png": 254,
	"./email/2-bullet@2x.png": 2201,
	"./email/3-bullet@2x.png": 8860,
	"./email/personalised-registrations-email-logo@2x.png": 1147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;